/*
  页面 UI 文案（中文）。

  · key 与 en.js 一一对应：哪边缺一个 key，页面上就会直接显示 key 本身。
  · 这里只管界面文字（表单、按钮、提示、报错）。SEO / 结构化数据 / llms.txt
    的文案在 src/seo/content.mjs，两边不要互相抄。
  · 提示与报错一律走 $t，别在 HomeView 里写死中文 —— 否则英文用户看到的是中文。
*/
export default {
  home: {
    /* ---------------------------- 顶栏 / 页头 ---------------------------- */
    wallet: '连接钱包',
    langLabel: '切换语言',
    MultiSender: '批量工具',
    currentChain: '当前网络',
    notConnected: '未连接钱包',
    chainUnknown: '读不出当前网络',
    chainIdLabel: '链 ID',
    nativeCoin: '原生币',
    unlistedChainHint:
      '这个 chainId 不在价目表里，费用按 1 个原生币的兜底值收取。如果你其实在 Polygon、BNB Chain 这类常见链上，多半是钱包给这条链配了自定义 RPC（它的网络 ID 和链上的 chainId 对不上），换回官方 RPC 就正常了。',

    /* ---------------------------- 页头 / 这条通道能做什么 ---------------------------- */
    anyChainTitle: '任意链发币',
    anyChainLead:
      '连着哪条链，就在哪条链上发币 —— 不经过任何平台合约，字节码直接交给你的钱包部署。新链、冷门链用这里。',
    anyChainCan: '这条通道能做什么',
    anyChainCan1: '部署代币，立刻拿到合约地址',
    anyChainCan2: '用这条链自己的 DEX 加池、交易',
    anyChainCant1: '靓号合约地址（需要工厂合约，这里没有）',
    anyChainCant2: '代币管理 / 市值机器人 / 锁仓（要平台收录这条链）',
    anyChainFeeNote:
      '费用直接进部署交易的 value，由代币构造函数转给平台收款地址 —— 部署成功即已付费，不需要后台记账。',
    anyChainTip: '想用全套工具（靓号、代币管理、市值机器人），请用平台收录的链去新站的「创建代币」。',

    /* ---------------------------- 创建代币 ---------------------------- */
    chuangjian: '创建代币',
    creating: '部署中…',
    moshi: '代币模式',
    biaozhun: '标准代币',
    biaozhunTip: '名称 / 符号 / 精度 / 总量 / 所有者',
    shouxufei: '纯手续费代币',
    shouxufeiTip: '标准代币 + 营销税 / 销毁税 / 营销钱包',

    quancheng: '代币名称',
    quancheng1: '请输入代币名称',
    jiancheng: '代币符号',
    jiancheng1: '请输入代币符号',
    jingdu: '代币精度',
    zongliang: '供应总量',
    guanli: '管理员地址',
    admdizhi: '请输入管理员地址',
    yingxiao: '营销税（%）',
    ranshao: '销毁税（%）',
    yingxiaodizhi: '营销钱包地址',
    yingxiaodizhiPh: '请输入营销钱包地址',

    /* ---------------------------- 开源参数 ---------------------------- */
    kaiyuan: '开源参数',
    yuandaima: '复制源代码',
    canshu: '复制构造参数',

    /* ---------------------------- 代币工具 ---------------------------- */
    toolsTitle: '代币工具',
    toolsLead: '填入代币地址后，可以放弃该合约的所有权。',
    tokenAddr: '代币地址',
    daibidizhi: '请输入代币地址',
    toolAddrHint: '填写要做所有权操作的代币合约地址。',
    fangqi: '放弃所有权',
    queding: '确定',
    toolFangqiHint:
      '把合约所有权转给黑洞地址（0x…dEaD）。转出去之后，包括你在内任何人都改不了这个代币的设置，而且不可撤销。',

    /* ---------------------------- 页脚 / 赞助 ---------------------------- */
    footerBlurb: '多链代币创建、批量空投、流动性锁定与链上管理工具，连接钱包即可使用。',
    contactTitle: '社区与支持',
    footerDisclaimer:
      '本工具仅用于区块链学习测试，禁止中国大陆用户使用，如用于违法行为，与本站无关。',
    supportTitle: '支持 GTokenTool',
    kafei: '请我喝杯咖啡',
    qrAlt: 'GTokenTool 收款二维码',
    copyAddr: '复制地址',

    /* ---------------------------- 操作反馈 ---------------------------- */
    copyOk: '已复制',
    errUnknown: '未知原因',
    needWallet: '请先连接钱包',
    badTokenAddr: '代币地址格式不对',
    enterTokenAddr: '请输入代币地址',
    lowBalance: '余额不足',
    contractAddr: '合约地址：{addr}',
    contractLive: '合约已上链',
    txCancelled: '已取消这笔交易',
    deployFail: '部署失败：{msg}',
    renounceOk: '放弃所有权成功',
    renounceFail: '放弃所有权失败：{msg}',

    /* ---------------------------- 表单校验 ---------------------------- */
    vName: '请填写代币名称',
    vSymbol: '请填写代币符号',
    vDecimals: '代币精度要填 0-255 的整数',
    vSupply: '供应总量要填大于 0 的整数（整币数量，不能带小数点）',
    vAdmin: '管理员地址不是有效的钱包地址',
    vMarkFee: '营销税要填 0-100 的整数（百分数）',
    vBurnFee: '销毁税要填 0-100 的整数（百分数）',
    vMarkWallet: '营销钱包地址不是有效的钱包地址',
  },
}
